import styled from "styled-components";

const SliceProcessPageStyled = styled.div`

`

export default SliceProcessPageStyled;